import { FormHelperText } from "@mui/material";
import { styled } from "@mui/system";

const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  [`&.Mui-error`] :{
    color: theme.palette.error.dark,
  },
  marginTop: theme.spacing(0),
  marginLeft: theme.spacing(0)
}));
export default StyledFormHelperText;
